import React, { FC } from 'react';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { Typography } from '../../../../../components/Typography';
import { gray } from '../../../../../components/Color';
import { MovingGradient } from '../../../../../components/MovingGradient';
import { FlexGrid } from '../../../../../components/FlexGrid';

const skeleton = (
	<FlexGrid gap='tiny'>
		<MovingGradient
			borderRadius='6px'
			height='14px'
			width='4%'
		/>
		<span>•</span>
		<MovingGradient
			borderRadius='6px'
			height='14px'
			width='9%'
		/>
		<span>•</span>
		<MovingGradient
			borderRadius='6px'
			height='14px'
			width='7%'
		/>
	</FlexGrid>
);

export const PublicJobDetailMetadata: FC = () => {
	const {
		data: { formattedAddress, ageFormatted, employmentTypeName, jobTypeName },
		isLoading,
	} = usePublicJobDetailDataQuery();

	return (
		<Typography color={gray[6]}>
			{!isLoading &&
				[formattedAddress, ageFormatted, employmentTypeName, jobTypeName].filter(Boolean).join(' • ')}
			{isLoading && skeleton}
		</Typography>
	);
};
